import { mapActions } from 'vuex';

function cloneData(data) {
    if (data == undefined) return undefined

    return JSON.parse(JSON.stringify(data))
}

const FormChangeWatcherMixin = {
    mounted() {
        this.resetDirtyInputs()

        for (let input of this.formChangeWatcherSettings.inputs) {
            this.$watch(input, (n, o) => this.onFormInputChanged(input, n, o), {deep: true})
        }
    },

    methods: {
        ...mapActions(['modal/open', 'popups/settings/confirmDiscardChanges']),
        onFormInputChanged: function(key, newVal) {
            if (this.formChangeWatcherSettings.ignoreChange) {
                return
            }

            this.dirty = true

            let dirtiedInput = this.dirtiedInputs[key]
            dirtiedInput.newVal = newVal
            dirtiedInput.dirty = true
        },
        revertChanges() {
            this.ignoreChanges(() => {
                for (let input of this.formChangeWatcherSettings.inputs) {
                    this[input] = this.dirtiedInputs[input].oldVal
                }
            })

            this.resetDirtyInputs()
        },
        isInputDirty(key) {
            return this.dirtiedInputs[key] && this.dirtiedInputs[key].dirty
        },
        resetDirtyInputs() {
            this.dirty = false

            for (let input of this.formChangeWatcherSettings.inputs) {
                this.dirtiedInputs[input] = {
                    oldVal: cloneData(this[input]) || this.formChangeWatcherSettings.defaults[input] || undefined,
                    dirty: false
                }
            }
        },
        ignoreChanges(func) {
            this.formChangeWatcherSettings.ignoreChange = true

            func()

            // The watch is not called until afterwards, so we need to wait until the watch is triggered before
            // flicking it back
            this.$nextTick(() => {
                this.formChangeWatcherSettings.ignoreChange = false
            })
        },
        promptIfDirty(next) {
            if (this.dirty) {
                this['popups/settings/confirmDiscardChanges']({
                    dontSaveAndContinue: () => {
                        this.revertChanges()
                        next()
                    },
                    saveAndContinue: async () => {
                        await this.submit()
                        next()
                    }
                })
            } else {
                next()
            }
        }
    },

    beforeRouteLeave(to, from, next) {
        if (this.formChangeWatcherSettings.promptOnLeave) {
            this.promptIfDirty(next)
        } else {
            next()
        }
    },

    data: function() {
        return {
            dirty: false,
            dirtiedInputs: {}
        }
    }
}

export default FormChangeWatcherMixin
